import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Moon($$anchor, $$props) {
	const iconNode = [
		[
			"path",

			{
				"d": "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"
			}
		]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiTW9vbi5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJNMjAuOTg1IDEyLjQ4NmE5IDkgMCAxIDEtOS40NzMtOS40NzJjLjQwNS0uMDIyLjYxNy40Ni40MDIuODAzYTYgNiAwIDAgMCA4LjI2OCA4LjI2OGMuMzQ0LS4yMTUuODI1LS4wMDQuODAzLjQwMVwiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7Z0RBRGxDLENBQUM7T0FFTyxRQUE0Qzs7R0FBSyxNQUFNOzs7SUFBSSxHQUFHLEVBQUUsZ0hBQWdIOzs7OztLQUNsTCxJQUFJOzs7Ozs7OztRQUVXLElBQUk7O0FBRDFCLENBQUMifQ==